//
//
//
//

import {
  resetShoppingCartSID,
} from '@/utils/helpers'
import {mapActions, mapMutations} from 'vuex'
import {adminCodes} from '~/enums/adminSettings'

export default {
  name: 'Logout',
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.isFrontendLogout = !from.path.includes('backoffice')
    })
  },
  data() {
    return {
      isFrontendLogout: false,
    }
  },
  async mounted() {
    await this.$auth.logout('local')
    resetShoppingCartSID()
    this.resetCheckoutAddresses()
    if (!this.$auth.loggedIn) {
      let adminSettingLogoutUrl = ''
      if (this.isFrontendLogout) {
        adminSettingLogoutUrl = await this.fetchAdminSettingByCode(
          adminCodes.REDIRECT_URL_AFTER_FRONTEND_LOGOUT
        )
      } else {
        adminSettingLogoutUrl = await this.fetchAdminSettingByCode(
          adminCodes.LOGOUT_URL
        )
      }
      localStorage.removeItem('notificationPQLApprovalAcknowledged');
      if (adminSettingLogoutUrl && adminSettingLogoutUrl.value) {
        window.location = `/${adminSettingLogoutUrl.value.replace(/^\/+/g, '')}`
      }
      else {
        window.location = `/`
      }
    }
  },
  methods: {
    ...mapMutations('shoppingCartCheckoutAddresses', [
      'resetCheckoutAddresses',
    ]),
    ...mapActions('backoffice/settings', ['fetchAdminSettingByCode']),
  },
}
